import * as Constants from '../../constants/resources';
import {
  Passwords,
  PasswordDetailData
} from '../../types/resources/State';

export interface RequestPasswords {
  type: Constants.PASSWORDS;
  payload: {
    currentPage: number;
    pageSize: number;
    filter: string;
  };
}

export interface RequestPasswordsSuccess {
  type: Constants.PASSWORDS_SUCCESS;
  payload: {
    passwords: Passwords;
  };
}
export interface RequestPasswordsFailed {
  type: Constants.PASSWORDS_FAILED;
}

export interface RequestPasswordDetail {
  type: Constants.PASSWORD_DETAIL;
  passwordVMID: string;
}

export interface RequestPasswordDetailSuccess {
  type: Constants.PASSWORD_DETAIL_SUCCESS;
  payload: {
    passwordDetail: PasswordDetailData;
  };
}

export interface RequestPasswordDetailFailed {
  type: Constants.PASSWORD_DETAIL_FAILED;
}

export type PasswordAction =
  | RequestPasswords
  | RequestPasswordsSuccess
  | RequestPasswordsFailed
  | RequestPasswordDetail
  | RequestPasswordDetailSuccess
  | RequestPasswordDetailFailed;

export const requestPasswords = (
  currentPage: number,
  pageSize: number,
  filter: string
): RequestPasswords => ({
  type: Constants.PASSWORDS,
  payload: { currentPage, pageSize, filter }
});

export const requestPasswordsSuccess = (
  passwords: Passwords
): RequestPasswordsSuccess => ({
  payload: { passwords },
  type: Constants.PASSWORDS_SUCCESS
});
export const requestPasswordsFailed = (): RequestPasswordsFailed => ({
  type: Constants.PASSWORDS_FAILED
});
export const requestPasswordDetail = (
  passwordVMID: string
): RequestPasswordDetail => ({
  type: Constants.PASSWORD_DETAIL,
  passwordVMID
});
export const requestPasswordDetailSuccess = (
  passwordDetail: PasswordDetailData
): RequestPasswordDetailSuccess => ({
  payload: { passwordDetail },
  type: Constants.PASSWORD_DETAIL_SUCCESS
});
export const requestPasswordDetailFailed = (): RequestPasswordDetailFailed => ({
  type: Constants.PASSWORD_DETAIL_FAILED
});
